import { useRef } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import queryString from 'qs'

import Terms from '../legal/Terms'
import { Submit } from '../form'
import AuthTextField from './AuthTextField'
import { InputGroup, Center, AuthToken, Column } from './shared'

const IntroText = styled.div`
  font-size: 21px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textGreyDarker};
`

const validationSchema = Yup.object({
  user: Yup.object({
    password: Yup.string()
      .required('This field is required')
      .min(8, 'Password should be at least 8+ characters'),
    password_confirmation: Yup.string()
      .required('This field is required')
      .oneOf(
        [Yup.ref('password')],
        'Password confirmation should match password'
      ),
  }),
})

const SetPassword = ({ location }) => {
  const formElement = useRef(null)
  const {
    invitation_token,
    invitation_type,
  } = queryString.parse(location.search, { ignoreQueryPrefix: true })
  const isStorytellerInvitation = invitation_type === 'storyteller'

  const form = useForm({
    mode: 'onSubmit',
    resolver: yupResolver(validationSchema),
    defaultValues: { user: { password: '', password_confirmation: '' } },
  })
  const {
    handleSubmit,
    formState: { isDirty },
  } = form

  return (
    <FormProvider {...form}>
      <form
        className="qa-set-password"
        action="/users/invitation"
        method="post"
        ref={formElement}
        onSubmit={handleSubmit(() => formElement.current.submit())}
      >
        <AuthToken />
        <input type="hidden" name="_method" value="put" />
        <input
          type="hidden"
          value={invitation_token}
          name="user[invitation_token]"
        />

        <div className="container">
          <div className="row">
            <Column className="col-xs-12 col-md-6 col-md-push-3">
              <IntroText className="mb-5">
                First, we need you to set a password to keep your new Riparide
                account secure.
              </IntroText>

              {!isStorytellerInvitation && (
                <IntroText className="mb-5">
                  Don&apos;t worry though, this doesn&apos;t commit you to
                  listing with us. You&apos;ll have the opportunity to review
                  all the details before you decide to publish.
                </IntroText>
              )}

              <AuthTextField
                label="New password"
                name="user[password]"
                type="password"
                lessMargin
              />
              <AuthTextField
                label="Confirm new password"
                name="user[password_confirmation]"
                type="password"
                lessMargin
              />

              <InputGroup>
                <Terms />
              </InputGroup>

              <InputGroup>
                <Center>
                  <Submit name="commit" disabled={!isDirty}>
                    Continue
                  </Submit>
                </Center>
              </InputGroup>
            </Column>
          </div>
        </div>
      </form>
    </FormProvider>
  )
}

export default connect(({ auth }) => ({
  currentUser: auth.currentUser,
}))(SetPassword)
